import { SVGProps, Ref, forwardRef } from 'react';

export const CrossCircleOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.8 12c0 2.483.624 4.772 1.989 6.41C6.106 19.99 8.308 21.2 12 21.2s5.894-1.21 7.211-2.79C20.576 16.772 21.2 14.483 21.2 12s-.624-4.772-1.989-6.41C17.894 4.01 15.692 2.8 12 2.8S6.106 4.01 4.789 5.59C3.424 7.228 2.8 9.517 2.8 12M1 12c0 5.5 2.75 11 11 11s11-5.5 11-11S20.25 1 12 1 1 6.5 1 12m7.636-4.636L12 10.727l3.364-3.363 1.272 1.272L13.273 12l3.363 3.364-1.272 1.273L12 13.273l-3.364 3.364-1.272-1.273L10.727 12 7.364 8.636z"
            fill="currentColor"
        />
    </svg>
));
CrossCircleOutlinedSize24Glyph.displayName = 'CrossCircleOutlinedSize24Glyph';
